module.exports = __webpack_public_path__ + "static/media/bell-bicycle1.019ec529.aac";